import React from "react";
import Grid from "@material-ui/core/Grid";
import CalculatorCategoryBox from "./CalculatorCategoryBox";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: '40px',
        marginBottom: '40px'
    }
}));

const CalculatorsList = (props) => {
    const styles = useStyles();

    return (
        <div className={styles.root}>
            <Grid container spacing={5}>
                {props.sheetsBoxes.map(sheetsBox => (
                    <Grid item xs={12}>
                        <CalculatorCategoryBox title={sheetsBox.title} sheets={sheetsBox.sheets}/>
                    </Grid>
                ))}
            </Grid>
        </div>
    )
};

export default CalculatorsList;